export default "__VITE_ASSET__CZVWQ2VY__"